// ink-component
import React, { ReactNode } from 'react';

import { bemHelper } from '../../../helpers';

import useDeprecatedWarning from '../../../hooks/useDeprecatedWarning';
import getGlobalProps from '../../../helpers/constants/global-props';

export interface TileRowProps {
  /** Contents, can only have a maximum of 12 nodes */
  children?: ReactNode;
  /** Arrangment of grid items */
  arrangement?: 'auto' | 'equal';
}

const globalProps = getGlobalProps({ deprecated: true, inkSass: true });

/**
 * @purpose Wrapper for horizontal tiles to line up in a row
 * @deprecated This component is deprecated and replaced by [Tiles](https://ink.carta.com/components/Tiles/)
 * @status deprecated
 * @replacementComponent Tiles
 * @dateOfDeletion December 1st, 2023
 */
function TileRow({ arrangement = 'auto', children, ...props }: TileRowProps) {
  useDeprecatedWarning({ componentName: 'TileRow', substitute: 'Tiles' });

  function renderChildren() {
    return React.Children.toArray(children).filter(child => child);
  }

  function defineClassName() {
    const b = bemHelper();
    const columns = React.Children.count(renderChildren());

    return b('ink-tile-row', {
      [columns]: Boolean(columns),
      [arrangement]: Boolean(arrangement),
    });
  }

  return (
    <div className={defineClassName()} data-testid={props['data-testid']} {...globalProps}>
      {renderChildren()}
    </div>
  );
}

TileRow.defaultProps = {
  children: undefined,
  arrangement: 'auto',
};

TileRow.displayName = 'TileRow';

export default TileRow;
